import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import ActionBarIcon from '../../../_partials/ActionBarIcon';
import Download from '../../../../Icons/24x24/Download';
import FreeAndPcpPopover from '../FreeAndPcpPopover';
import ActionBarItemWrapper from '../../../_partials/items/ActionBarItemWrapper';
import ActionBarButton from '../../../_partials/items/ActionBarButton';
export var DownloadButtonWithPopover = function (_a) {
    var deviation = _a.deviation, isLoggedIn = _a.isLoggedIn, restrictLoggedOut = _a.restrictLoggedOut, onDownload = _a.onDownload, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, iconRef = _a.iconRef;
    var t = useTranslation().t;
    return (React.createElement(ActionBarItemWrapper, { tooltip: t('actionbar.download'), renderPopover: isLoggedIn
            ? function (_a) {
                var closeTooltip = _a.closeTooltip;
                return (React.createElement(FreeAndPcpPopover, { deviation: deviation, closeTooltip: closeTooltip, onDownload: onDownload }));
            }
            : undefined },
        React.createElement(ActionBarButton, { onClick: isLoggedIn ? undefined : restrictLoggedOut, onMouseEnter: isLoggedIn ? onMouseEnter : undefined, onMouseLeave: isLoggedIn ? onMouseLeave : undefined, biData: {
                evid: BiEventType.CLICK_DOWNLOAD_BUTTON,
                deviationid: deviation.deviationId,
                ispaiddownload: 1,
            } },
            React.createElement(ActionBarIcon, { icon: Download, iconRef: iconRef }))));
};
DownloadButtonWithPopover.displayName = 'DownloadButtonWithPopover';
export default DownloadButtonWithPopover;
//# sourceMappingURL=DownloadButtonWithPopover.js.map